const e = "styles-module__dateInputWrapper___-T-Ax", t = "styles-module__dateInput___n6EC0", _ = "styles-module__error___CGeAT", r = "styles-module__calendarIcon___CIRlM", n = {
  dateInputWrapper: e,
  dateInput: t,
  error: _,
  calendarIcon: r
};
export {
  r as calendarIcon,
  t as dateInput,
  e as dateInputWrapper,
  n as default,
  _ as error
};
